import React from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../common/routes';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import SystemClient from '../../system/SystemClient';
import { Partido } from '../../system/Partido/Partido';
import { Equipo } from '../../system/Equipo/Equipo';
import { Label, Text, Icon, Toggle, TextField } from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import DialogTemplate from './DialogTemplate';
import { ArbitroSelector } from '../Arbitro/ArbitroSelector';
import { Arbitro } from '../../system/Arbitro/Arbitro';
import XhrRequestError from '../../lib/XhrRequestError';

interface ICesionPuntos {
  partido: Partido;
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (v: boolean) => void;
  onCesionOk: () => void;
  onCesionError?: () => void;
  onCesionAmbosOk: () => void;
  onCesionAmbosError?: () => void;
}
export const CesionPuntos = (props: ICesionPuntos) => {
  const [openErrorPuntosPartidoDialog, setOpenErrorPuntosPartidoDialog] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const [equipo, setEquipo] = React.useState<Equipo | undefined>(undefined);
  const [confirmDialog, setConfirmDialog] = React.useState<boolean>(false);
  const cedePuntosEquipoEspecifico = async (partido: Partido, equipoId: string) => {
    try {
      props.changeBlockUI(true);
      if (partido) {
        const cedePuntos = await props.system
          .getPartidoSystem()
          .cedePuntosEquipoEspecifico(String(partido.getId()), equipoId);
      }
      props.courier.messageSuccess('Se cedieron los puntos del partido correctamente');
      props.changeBlockUI(false);
      props.onCesionOk();
      // if (searchOverlap) {
      //   searchOverlap();
      // }
      // setOpenIngresarResultado(false);
      // setPartidoToIngresarResultado(undefined);
    } catch (err) {
      props.courier.messageError(err);
      if (err instanceof XhrRequestError) {
        const errorMessage = err.getApiErrorMessage();
        if (
          errorMessage.includes(
            'No se encontraron datos de la asignacion de puntos para la federación y categoria correspondiente'
          )
        ) {
          setOpenErrorPuntosPartidoDialog(true);
        }
      }
    } finally {
      props.changeBlockUI(false);
    }
  };

  const cedePuntosAmbos = async (partido: Partido) => {
    try {
      props.changeBlockUI(true);
      if (partido) {
        const cedePuntos = await props.system.getPartidoSystem().cedePuntosAmbos(String(partido.getId()));
        props.changeBlockUI(false);
        props.onCesionAmbosOk();

        //   if (searchOverlap) {
        //     searchOverlap();
        //   }
        // }
        // setOpenIngresarResultado(false);
        // setPartidoToIngresarResultado(undefined);
        // reset();
        props.courier.messageSuccess('Se cedieron los puntos del partido correctamente');
      }
    } catch (err) {
      props.courier.messageError(err);
      if (err instanceof XhrRequestError) {
        const errorMessage = err.getApiErrorMessage();
        const partidoEstadoIncorrecto = err.apiErrorCodeIs('428');
        if (
          errorMessage.includes(
            'No se encontraron datos de la asignacion de puntos para la federación y categoria correspondiente'
          )
        ) {
          setOpenErrorPuntosPartidoDialog(true);
        }
      }
    } finally {
      props.changeBlockUI(false);
    }
  };
  const confirm = async () => {
    try {
      if (equipo) {
        cedePuntosEquipoEspecifico(props.partido, equipo.getId()!);
      } else {
        cedePuntosAmbos(props.partido);
      }
      setOpenErrorPuntosPartidoDialog(false);
    } catch (err) {
      console.log('error');
    } finally {
    }
  };

  return (
    <div>
      {!props.partido.estaReprogramado() && (
        <div className="ms-Grid-row mt-1">
          <div className="ms-Grid-col ms-sm12">
            <span
              className={
                props.partido.getVisitante()?.getSePresenta() ? 'link-styles' : 'link-styles-disabled'
              }
              onClick={() => {
                if (props.partido.getVisitante()?.getSePresenta()) {
                  setEquipo(props.partido.getLocal()!);
                  setConfirmDialog(true);

                  // cedePuntosEquipoEspecifico(props.partido, String(props.partido.getLocal()?.getId()));
                }
              }}
            >
              <Icon iconName="ShieldAlert" className="mr-1" />
              {props.partido.getLocal()?.getFullnameClub()} cede los puntos
            </span>
          </div>
        </div>
      )}
      {!props.partido.estaReprogramado() && (
        <div className="ms-Grid-row mt-1">
          <div className="ms-Grid-col ms-sm12">
            <span
              className={props.partido.getLocal()?.getSePresenta() ? 'link-styles' : 'link-styles-disabled'}
              onClick={() => {
                if (props.partido.getLocal()?.getSePresenta()) {
                  setEquipo(props.partido.getVisitante()!);
                  setConfirmDialog(true);

                  // cedePuntosEquipoEspecifico(props.partido, String(props.partido.getVisitante()?.getId()));
                }
              }}
            >
              <Icon iconName="ShieldAlert" className="mr-1" />
              {props.partido.getVisitante()?.getFullnameClub()} cede los puntos
            </span>
          </div>
        </div>
      )}

      {!props.partido.estaReprogramado() && (
        <div className="ms-Grid-row mt-1">
          <div className="ms-Grid-col ms-sm12">
            <span
              className={
                props.partido.getFase()?.getTorneoTipo()?.isGrilla() ||
                !props.partido.getLocal()?.getSePresenta() ||
                !props.partido.getVisitante()?.getSePresenta()
                  ? 'link-styles-disabled'
                  : 'link-styles'
              }
              onClick={() => {
                if (
                  !props.partido.getFase()?.getTorneoTipo()?.isGrilla() &&
                  props.partido.getLocal()?.getSePresenta() &&
                  props.partido.getVisitante()?.getSePresenta()
                ) {
                  setEquipo(undefined);
                  setConfirmDialog(true);

                  // cedePuntosAmbos(props.partido);
                }
              }}
            >
              <Icon iconName="ShieldAlert" className="mr-1" />
              Ambos equipos ceden los puntos
            </span>
          </div>
        </div>
      )}
      <DialogTemplate
        showDialog={openErrorPuntosPartidoDialog}
        toggleShowDialog={() => {
          setOpenErrorPuntosPartidoDialog(false);
        }}
        title={'Error en la cesión de puntos'}
        onAccept={() => navigate(`${routes.puntos_partido.route}`)}
        onCancel={() => {
          setOpenErrorPuntosPartidoDialog(false);
        }}
        acceptText="Establecer puntos"
        cancelText="Volver al formulario"
        minWidth={600}
      >
        <Text className="error-message" variant="medium">
          {/* <Icon iconName="Cancel" className="text-icon" style={{ color: 'red' }}></Icon> */}
          No se encontraron datos de la asignacion de puntos para l a federación y categoria correspondiente
        </Text>
      </DialogTemplate>

      <DialogTemplate
        showDialog={confirmDialog}
        toggleShowDialog={() => {
          setConfirmDialog(false);
          setEquipo(undefined);
        }}
        title={'Confirmar cesión de puntos'}
        onCancel={() => {
          setConfirmDialog(false);
          setEquipo(undefined);
        }}
        onAccept={confirm}
        acceptText="Confirmar"
        cancelText="Volver"
        minWidth={600}
      >
        <Text className="" variant="mediumPlus">
          Confirmar la cesión de puntos de {equipo ? equipo?.getFullnameClub() : 'Ambos equipos'}
        </Text>
      </DialogTemplate>
    </div>
  );
};
